(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bala-pdf-modal-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bala-pdf-modal')) {
    class BalaPdfModal extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        this.openButton = this.querySelector('[data-pdf-open]');
        this.closeButton = this.querySelector('[data-pdf-close]');
        this.dialog = this.querySelector('[data-pdf-dialog]');
        this.frame = this.querySelector('[data-pdf-frame]');
        this.downloadButton = this.querySelector('[data-pdf-download]');

        if (!this.openButton || !this.closeButton || !this.dialog || !this.frame) return;

        this.openButton.addEventListener('click', () => this.open());
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.afterClose());

        if (this.downloadButton) {
          this.downloadButton.addEventListener('click', () => this.download());
        }
      }

      open() {
        const source = this.frame.dataset.src;
        if (source && this.frame.getAttribute('src') !== source) {
          this.frame.setAttribute('src', source);
        }

        this.dialog.showModal();
        document.body.classList.add('bala-pdf-modal-open');
      }

      afterClose() {
        document.body.classList.remove('bala-pdf-modal-open');
        this.frame.setAttribute('src', 'about:blank');
        this.openButton.focus();
      }

      async download() {
        const url = this.downloadButton.dataset.pdfUrl;
        const filename = this.downloadButton.dataset.pdfFilename || 'Bala-Sport-document.pdf';

        if (!url) return;

        this.downloadButton.disabled = true;

        try {
          const response = await fetch(url, { credentials: 'omit' });
          if (!response.ok) throw new Error('Download failed');

          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = objectUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(objectUrl);
        } catch (error) {
          window.open(url, '_blank', 'noopener');
        } finally {
          this.downloadButton.disabled = false;
        }
      }
    }

    customElements.define('bala-pdf-modal', BalaPdfModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bala-retail-pack-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retail-pack-choice')) {
    class RetailPackChoice extends HTMLElement {
      constructor() {
        super();

        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector('[data-pack-choice-trigger]');
        this.panel = this.querySelector('[data-pack-choice-panel]');
        this.closeButton = this.querySelector('[data-pack-choice-close]');
        this.downloadLink = this.querySelector('[data-retail-pack-download]');

        if (!this.trigger || !this.panel) return;

        if (!this.hasAttribute('data-initialised')) {
          this.trigger.addEventListener('click', () => this.togglePanel());

          if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.closePanel(true));
          }

          if (this.downloadLink) {
            this.downloadLink.addEventListener(
              'click',
              (event) => this.forceDownload(event)
            );
          }

          this.setAttribute('data-initialised', '');
        }

        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      togglePanel() {
        if (this.panel.hidden) {
          this.openPanel();
        } else {
          this.closePanel();
        }
      }

      openPanel() {
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      closePanel(returnFocus = false) {
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');

        if (returnFocus) {
          this.trigger.focus();
        }
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.closePanel();
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && !this.panel.hidden) {
          this.closePanel(true);
        }
      }

      async forceDownload(event) {
        event.preventDefault();

        const link = event.currentTarget;

        if (link.getAttribute('aria-busy') === 'true') return;

        const fileUrl = link.href;
        const originalText = link.textContent;

        link.setAttribute('aria-busy', 'true');
        link.textContent = 'Preparing download…';

        try {
          const response = await fetch(fileUrl, {
            credentials: 'omit'
          });

          if (!response.ok) {
            throw new Error('The file could not be downloaded');
          }

          const fileBlob = await response.blob();
          const temporaryUrl = URL.createObjectURL(fileBlob);
          const helperLink = document.createElement('a');
          const urlParts = new URL(fileUrl);
          const filename =
            decodeURIComponent(urlParts.pathname.split('/').pop()) ||
            'Bala-Retail-Partner-Pack.pdf';

          helperLink.href = temporaryUrl;
          helperLink.download = filename;
          helperLink.style.display = 'none';

          document.body.appendChild(helperLink);
          helperLink.click();
          helperLink.remove();

          window.setTimeout(() => {
            URL.revokeObjectURL(temporaryUrl);
          }, 2000);

          this.closePanel();
        } catch (error) {
          window.open(fileUrl, '_blank', 'noopener');
        } finally {
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
        }
      }
    }

    customElements.define('retail-pack-choice', RetailPackChoice);
  }
  } catch(e) { console.error(e); }
})();

})();
